import { EntityMetaData } from '@/player-config/src/types/remotion-types';

export interface AIRecipe {
  id: string;
  recipe_name: string;
  description: string | null;
  recipe_type: 'Default' | 'Custom';
  recipe: string;
  tags: { [key: string]: any };
  key?: 'recommended' | 'recently used';
}

export interface AIAgentStreamingResponse {
  agent_name: string;
  response: string;
  timestamp: Date;
  asset_id: string;
  is_thinking: boolean;
}

export interface TextElementInput {
  id: string;
  start: number;
  duration: number;
  text: string;
  metadata?: EntityMetaData;
}

export interface Font {
  name: string;
  location: string;
}

export interface AIEditsSplitConfig {
  splitIndex: number;
  fromFrame: number;
  toFrame: number;
  trims: [number, number][];
  effects: any[];
  layouts: any[];
}

export interface AIEditsConfigWithSplits {
  font: Font;
  splits: AIEditsSplitConfig[];
  elements: {
    images: any[];
    videos: any[];
    music: any[];
    text: any[];
  };
}

export const AGENT_STATES = {
  UNINITIALIZED: 'Uninitialized',
  IDLE: 'Idle',
  PLANNING: 'Planning',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  APPLIED: 'Applied'
} as const;
